import React, { useState, useRef } from 'react';
import ErrorBoundary from './ErrorBoundary';
import useOutsideClick from '../hooks/useOutsideClick';

function BlogSortDropdown({ tags }) {
  const dropdownRef = useRef(null);

  const [selectedTag, setSelectedTag] = useState(null);

  const checkVisibility = () =>
    !document.querySelector('.blog-sort-dropdown').classList.contains('hidden');

  const toggleDropdownVisible = () => {
    document.querySelector('.blog-sort-dropdown').classList.toggle('hidden');
  };

  useOutsideClick(dropdownRef, true, () => {
    const isVisible = checkVisibility();
    if (isVisible) {
      toggleDropdownVisible();
    }
  });

  const handleChange = (e, tag) => {
    // Escape the period in the tag name (if applicable) so querySelector does not mistake it to be a css class
    let tagWithEscapedPeriod = null;
    if (tag.includes('.')) {
      const indexOfPeriod = tag.indexOf('.');
      tagWithEscapedPeriod = `${tag.slice(0, indexOfPeriod)}\\${tag.slice(
        indexOfPeriod
      )}`;
    }

    const checkboxes = document.querySelectorAll('.blog-sort-dropdown > label');
    const formSelect = document.querySelector('#q_any_tags');
    const tagSelected = document.querySelector(
      `#blog-sort-${tagWithEscapedPeriod || tag}`
    ).checked;
    if (!tagSelected) {
      formSelect.value = null;
      setSelectedTag(null);
    } else {
      formSelect.value = tag;
      setSelectedTag(tag);
    }

    checkboxes.forEach(checkbox => {
      if (checkbox.firstElementChild !== e.target)
        checkbox.firstElementChild.checked = false;
    });
  };

  const handleFormClear = e => {
    e.preventDefault();
    const form = document.querySelector('#article-search-form');
    const formSelect = document.querySelector('#q_any_tags');
    const sortByButton = document.querySelector('#blog-sort-by');

    formSelect.value = null;
    const checkboxes = document.querySelectorAll('.blog-sort-dropdown > label');
    checkboxes.forEach(checkbox => {
      checkbox.firstElementChild.checked = false;
    });
    sortByButton.innerText = 'Sort By';
    toggleDropdownVisible();
    window.Rails.fire(form, 'submit'); // This is how to submit a remote form from React
    setSelectedTag(null);
  };

  const handleSubmit = e => {
    e.preventDefault();
    const sortByButton = document.querySelector('#blog-sort-by');
    const form = document.querySelector('#article-search-form');
    toggleDropdownVisible();
    sortByButton.innerText = selectedTag || 'Sort By';
    window.Rails.fire(form, 'submit'); // This is how to submit a remote form from React
  };

  return (
    <section
      ref={dropdownRef}
      className="dropdown-sorting-inputs blog-sort-dropdown hidden"
    >
      {tags.map((tag, ind) => (
        <label key={ind} htmlFor={`blog-sort-${tag}`}>
          <input
            aria-label={`blog-sort-${tag}`}
            onChange={e => handleChange(e, tag)}
            id={`blog-sort-${tag}`}
            type="checkbox"
            checked={tag === selectedTag}
          />
          <p className="blog-sort-tag">{tag}</p>
        </label>
      ))}
      <section className="dropdown-actions">
        <button
          type="button"
          className="btn btn--dark btn--small"
          onClick={handleSubmit}
          aria-label="Apply Filters"
          name="Apply Filters"
        >
          Apply
        </button>
        <button
          type="button"
          className="btn btn--light btn--small"
          onClick={handleFormClear}
          aria-label="Clear Filters"
          name="Clear Filters"
        >
          Clear
        </button>
      </section>
    </section>
  );
}

export default function BlogSortDropdownWrapper({ ...props }) {
  return (
    <ErrorBoundary>
      <BlogSortDropdown {...props} />
    </ErrorBoundary>
  );
}
